<template>
  <div class="rebate">
    <br>
    <div>
      <h4 v-if="program.categories ? program.categories.length > 0 : false" class="text-left"><a href="#" class="admin-clickable" @click.prevent="editCategories = true"><strong>Edit Categories</strong></a></h4>
      <h4 class="text-left"><a href="#" class="admin-clickable" @click.prevent="addRebateItem"><strong>Add Rebate Item</strong></a></h4>
      <a href="" @click.prevent="showDisabled = !showDisabled">{{ showDisabled ? 'Show Enabled' : 'Show Disabled' }}</a>
      <br>
      <div class="headers row text-center">
        <div class="col-sm-4">Name</div>
        <div class="col-sm-4">Unique Identifier</div>
        <div class="col-sm-4">Points</div>
      </div>
      <div
        class="reward-item row clickable blue-outline text-center"
        v-for="(item, index) in currentItems" :key="index"
        @click="editModal(item._id)"
        >
        <div class="col-sm-4">{{ item.name }}</div>
        <div class="col-sm-4">{{ item.uniqueIdentifier }}</div>
        <div class="col-sm-4">{{ item.points }}</div>
      </div>
    </div>

    <paginate
      v-model="currentPage"
      :page-count="pageCount"
      :click-handler="switchPage"
      :prev-text="'Prev'"
      :next-text="'Next'"
      :container-class="'pagination'">
    </paginate>

    <categories-modal
      :editCategories="editCategories"
      :program="program"
      v-on:close="closeCategoriesModal"
      ></categories-modal>

    <rebate-item-modal
      :editRebateItem="editRebateItem"
      :currentRebateItemId="currentRebateItemId"
      :program="program"
      :isNew="createModal"
      v-on:close="closeModal"
      ></rebate-item-modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import RebateItemModal from './RebateItemModal'
import CategoriesModal from './CategoriesModal'
import Paginate from 'vuejs-paginate'

export default {
  name: 'RebateContent',
  components: {
    'rebate-item-modal': RebateItemModal,
    'categories-modal': CategoriesModal,
    'paginate': Paginate
  },
  data () {
    return {
      editRebateItem: false,
      editCategories: false,
      currentRebateItemId: null,
      createModal: false,
      currentPage: 1,
      showDisabled: false
    }
  },
  computed: {
    ...mapState('loyaltyProgram', [
      'program'
    ]),
    filteredRebateItems () {
      return this.program.rebateItems.filter(item => this.showDisabled ? item.disabled : !item.disabled)
    },
    pageCount () {
      return Math.ceil(this.program.rebateItems.length / 10)
    },
    startIdx () {
      return (this.currentPage - 1) * 10
    },
    endIdx () {
      return this.currentPage * 10
    },
    currentItems () {
      return this.currentPage === this.pageCount
        ? this.filteredRebateItems.slice(this.startIdx)
        : this.filteredRebateItems.slice(this.startIdx, this.endIdx)
    }
  },
  methods: {
    ...mapMutations('loyaltyProgram', {
      updateProgram: 'UPDATE_PROGRAM'
    }),
    switchPage (page) {
      console.log(page)
    },
    addRebateItem () {
      const copy = this.program.rebateItems.slice()
      copy.push({})
      this.updateProgram({ prop: 'rebateItems', value: copy })
      this.currentRebateItemIndex = copy.length - 1
      this.createModal = true
      this.editRebateItem = true
    },
    editModal (currentItemId) {
      this.currentRebateItemId = currentItemId
      this.editRebateItem = true
    },
    closeModal () {
      this.editRebateItem = false
      this.currentRebateItemIndex = null
      this.createModal = false
    },
    closeCategoriesModal () {
      this.editCategories = false
    }
  }
}
</script>

<style scoped>

</style>
